let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ZyHZ")).then(() => parcelRequire('hjpzo'));